import React, { Component } from "react"
import "./index.css"
import Loading from '../shared/Loading';
import { m } from '../../utils';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import SwipeableViews from 'react-swipeable-views';
import Card from "../../artzu-ui/src/Card"
import Button from "../../artzu-ui/src/Button"
import ViewIndicator from "./ViewIndicator"
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPlus, faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';

const query = gql`
        query bookingCards($nextCount: Int!, $prevCount: Int!) {
            nextBookings(count: $nextCount) {
              id
              startTime
              endTime
              vehicleClass
              parkinglot {
                id
                city
                region
                accessCode
              }
              car {
                id
                plate
                parkingSpot
              }
            }
            pastBookings(count: $prevCount) {
              id
              startTime
              endTime
              vehicleClass
              parkinglot {
                id
                city
                region
                accessCode
              }
              car {
                id
                plate
                parkingSpot
              }
            }
          }
        `;

const styles = {
  root: {
    padding: '0 22.5vw',
    width: '100vw'
  },
  slide: {
    width: '50vw',
    margin: '0 2.5vw'
  },
  slide1: {
    background: '#fff',
    color: '#414141',
    borderColor: '#414141'
  },
  slide2: {
    background: '#fff',
    color: '#dedede',
    borderColor: '#dedede'
  },
  slide3: {
    background: '#6AC0FF',
  },
};

class BookingWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startTime: m().subtract(1, "week"),
      endTime: m().add(2, "week"),
      cardIndex: 0,
      indexAdjusted: false
    };
  }

  handleIndexChange = cardIndex => {
    this.setState({ cardIndex });
  }

  render() {
    const {
      cardIndex,
      indexAdjusted
    } = this.state;
    const {
      formatShift,
      status
    } = this.props;
    return (
      <Query
        query={query}
        variables={{ prevCount: 1, nextCount: 5}}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
        if(loading) return <div className="load-div"><Loading size="3x" /></div>;
        let bookCardData = data.pastBookings ? data.pastBookings.concat(data.nextBookings) : data.nextBookings
        let bookCount = bookCardData.length
        let startIndex = data.pastBookings.length > 0 ? 1 : 0;
        if(!indexAdjusted) this.setState({ cardIndex: startIndex, indexAdjusted: true });
        return (
          <div className="book-widget">
            <div className="book-top">
              <p>Booking</p>
              {status === "weekly_lease" ? null : <Link to="/mybookings">See All</Link>}
            </div>
            <SwipeableViews
              className="carousel swipa"
              style={styles.root}
              slideStyle={styles.slide}
              onChangeIndex={this.handleIndexChange}
              index={startIndex}
            >
              {bookCardData.map((booking, index) => {
                return (
                  <Card 
                    className="book-card" 
                    key={index}
                    // borderColor="#414141"
                    width="50vw"
                    style={Object.assign({}, cardIndex === index ? styles.slide1 : styles.slide2)}
                  >
                    <div className="card-title">
                      <strong>{m(booking.startTime).isAfter(m()) ? (index === startIndex ? "Next Booking" : "Booking")
                        : (m(booking.startTime).isBefore(m()) && m(booking.endTime).isAfter(m()) ? "Current Booking" : "Previous Booking")}</strong>
                    </div>
                    {status === "weekly_lease" ? 
                    <div className="card-time">
                      <strong>{m(booking.startTime).format('MMM D, YYYY')}</strong>
                      <p style={{margin: 0}}>{formatShift(m(booking.startTime).hour())} to </p>
                      <strong>{m(booking.endTime).format('MMM D, YYYY')}</strong>
                      <p>{formatShift(m(booking.endTime).hour())}</p>
                    </div>: 
                    <div className="card-time">
                      <div><b>{m(booking.startTime).format('dddd')},</b></div>
                      <strong>{m(booking.startTime).format('MMM D, YYYY')}</strong>
                      <p>{formatShift(m(booking.startTime).hour())} to {formatShift(m(booking.endTime).hour())}</p>
                    </div>}
                    {status === "weekly_lease" ? 
                    <div className="card-tier">
                      <strong>{booking.car ? booking.car.plate : null}</strong>
                    </div> : 
                    <div className="card-tier">
                      <strong>{booking.parkinglot.region[0].toUpperCase() + booking.parkinglot.region.substr(1)}</strong>
                      <p>{booking.vehicleClass.toUpperCase()}</p>
                    </div>}
                    <Link
                      className="details-link"
                      to={{ pathname: `/mybookings`, state: { bookId: booking.id, startTime: booking.startTime } }}>
                      <Button label="Details" color={cardIndex === index ? "#414141" : "#dedede"} fullWidth />
                    </Link>
                  </Card>
                );
              })}
              {status === "weekly_lease" ? null :
              <Card
                className="start-booking"
                key={bookCount}
                borderColor="#414141"
                width="50vw"
                style={Object.assign({}, cardIndex === bookCount ? styles.slide1 : styles.slide2)}
              >
                {bookCount > 0 ? 
                <Link to="/mybookings">
                    <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: "1.5em", marginBottom: "0.5em", color: cardIndex === bookCount ? "#414141" : "#dedede" }} />
                    <p style={{ color: cardIndex === bookCount ? "#414141" : "#dedede" }}>See more</p>
                </Link> :
                <Link to="/book">
                  <FontAwesomeIcon icon={faPlus} style={{fontSize: "1.5em", marginBottom: "0.5em"}} />
                  <p>Start booking</p>
                </Link>}
              </Card>}
            </SwipeableViews>
            <ViewIndicator dots={status === "weekly_lease" ? bookCount : bookCount + 1} index={cardIndex} active="#414141" inactive="#dedede" max={bookCardData.length} handleIndexChange={this.handleIndexChange} />
          </div>
        )
        }}
        </Query>
    )
  }
}

export default BookingWidget;


// WEBPACK FOOTER //
// ./src/components/NewDash/BookingWidget.js